import './sections/socials-feed-eleven.js';
import './sections/header-nav-mega.js';

import './snippets/subscription-selector.js';


document.addEventListener("DOMContentLoaded", function() {
    // close cookie policy on accept or devline click
    const cookieButtons = document.querySelectorAll('.shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-decline');

    cookieButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const cookiePolicyBanner = document.querySelector('.shopify-pc__banner__dialog');
            cookiePolicyBanner.style.display = 'none';
        });
    });
});
